import React, { Component } from "react";
import SvgLines from "react-mt-svg-lines";
import "./App.css";

class App extends Component {
  state = {};
  componentDidMount = () => {
    window.onscroll = function () {
      myFunction();
    };

    // Get the navbar
    var navbar = document.getElementById("navigationBar");

    // Get the offset position of the navbar
    var sticky = navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    }
  };

  navBarToggle = (e) => {
    // console.log("clicked");
    // e.preventDefault();
    // e.target.style.display = "contents";
    let x = document.getElementById("navigationList");
    let y = document.getElementById("animateSvg");
    // if (x.className === "") {
    //   x.className += "displayContents";
    // } else {
    //   x.className = "";
    // }
    if (x.style.display === "contents") {
      x.style.display = "none";
      y.style.display = "block";
    } else {
      x.style.display = "contents";
      y.style.display = "none";
    }
  };
  render() {
    return (
      <div>
        <div className="mainDiv">
          <div id="navigationBar" className="navigationBar">
            <div className="toggleButton" onClick={this.navBarToggle}>
              <i class="fa fa-bars"></i>
            </div>
            <div className="name">Usama</div>
            <div id="navigation" className="navigation">
              <ul id="navigationList">
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#aboutMe">About Me</a>
                </li>
                <li>
                  <a href="#skills">Skills</a>
                </li>
                <li>
                  <a href="#certificates">Certificate</a>
                </li>
                <li>
                  <a href="#works">Works</a>
                </li>
                <li>
                  <a href="#contactMe">Contact Me</a>
                </li>
              </ul>
            </div>
          </div>

          <div id="home" className="mainContent">
            <svg
              id="animateSvg"
              className="svgStyles"
              viewBox="0 0 487 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.84 52.576C16.8 52.576 12.912 52.168 10.176 51.352C7.44 50.536 5.424 49.216 4.128 47.392C2.928 45.712 2.184 43.576 1.896 40.984C1.608 38.392 1.464 34.528 1.464 29.392V2.464H15.864V32.272C15.864 34.048 15.912 35.752 16.008 37.384C16.104 38.68 16.32 39.616 16.656 40.192C16.992 40.768 17.568 41.128 18.384 41.272C19.104 41.464 20.256 41.56 21.84 41.56H23.496C23.88 41.56 24.312 41.512 24.792 41.416V52.504C24.456 52.552 23.976 52.576 23.352 52.576H21.84ZM27.816 2.464H42.216V29.392C42.216 34.096 42.12 37.648 41.928 40.048C41.736 42.448 41.208 44.464 40.344 46.096C39.384 47.968 37.92 49.408 35.952 50.416C33.984 51.424 31.272 52.072 27.816 52.36V2.464Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M85.5189 13.84C83.9349 13.648 81.1509 13.384 77.1669 13.048C74.9589 12.952 73.1829 12.904 71.8389 12.904C70.1109 12.904 68.4789 12.952 66.9429 13.048V1.888H68.7429C72.6789 1.888 76.7589 2.152 80.9829 2.68C82.3269 2.872 83.8389 3.136 85.5189 3.472V13.84ZM73.6389 37.384C73.6389 36.376 73.5669 35.656 73.4229 35.224C73.2789 34.744 73.0389 34.432 72.7029 34.288C72.3669 34.096 71.7909 33.952 70.9749 33.856L62.1189 32.776C56.8869 32.2 53.3589 30.496 51.5349 27.664C50.7189 26.464 50.1669 25 49.8789 23.272C49.5909 21.544 49.4469 19.432 49.4469 16.936C49.4469 11.608 50.8149 7.768 53.5509 5.416C55.7589 3.496 59.2149 2.368 63.9189 2.032V16.504C63.9189 17.128 63.9429 17.656 63.9909 18.088C64.0389 18.52 64.1349 18.856 64.2789 19.096C64.4229 19.384 64.6629 19.6 64.9989 19.744C65.3349 19.84 65.8389 19.912 66.5109 19.96L76.4469 21.184C78.5109 21.472 80.1909 21.832 81.4869 22.264C82.7829 22.696 83.8869 23.368 84.7989 24.28C86.9589 26.536 88.0389 30.544 88.0389 36.304C88.0389 42.4 86.6949 46.672 84.0069 49.12C82.8069 50.224 81.3429 51.04 79.6149 51.568C77.9349 52.048 75.9429 52.36 73.6389 52.504V37.384ZM69.8229 52.576C65.0229 52.576 60.5589 52.36 56.4309 51.928C53.9829 51.688 52.1349 51.448 50.8869 51.208V40.696C53.7189 40.936 56.9589 41.176 60.6069 41.416C62.9109 41.512 64.5429 41.56 65.5029 41.56C68.0949 41.56 69.7989 41.488 70.6149 41.344V52.576H69.8229Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M106.709 2.464H107.933L113.621 22.192L105.341 52H90.9409L106.709 2.464ZM122.909 43.216H110.885L113.909 32.128H119.669L111.173 2.464H124.349L140.117 52H125.429L122.909 43.216Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M144.907 4.624V2.464H158.155L178.891 46.528L176.515 52H167.155L144.907 4.624ZM185.587 31.192H185.299L180.475 42.856L174.283 29.608L185.587 2.464H199.267V52H185.587V31.192ZM144.907 11.752L158.155 39.976V52H144.907V11.752Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M219.842 2.464H221.066L226.754 22.192L218.474 52H204.074L219.842 2.464ZM236.042 43.216H224.018L227.042 32.128H232.802L224.306 2.464H237.482L253.25 52H238.562L236.042 43.216Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M276.743 4.624V2.464H289.991L310.727 46.528L308.351 52H298.991L276.743 4.624ZM317.423 31.192H317.134L312.31 42.856L306.119 29.608L317.423 2.464H331.103V52H317.423V31.192ZM276.743 11.752L289.991 39.976V52H276.743V11.752Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M351.678 2.464H352.902L358.59 22.192L350.31 52H335.91L351.678 2.464ZM367.878 43.216H355.854L358.878 32.128H364.638L356.142 2.464H369.318L385.086 52H370.398L367.878 43.216Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M386.635 41.56C389.227 41.56 391.219 41.488 392.611 41.344C394.003 41.2 395.011 40.84 395.635 40.264C396.307 39.64 396.691 38.752 396.787 37.6C396.883 36.064 396.931 34.48 396.931 32.848V2.464H411.331V27.952C411.331 32.56 411.259 36.088 411.115 38.536C410.971 40.984 410.659 43.024 410.179 44.656C409.651 46.432 408.859 47.824 407.803 48.832C406.795 49.792 405.379 50.512 403.555 50.992C401.875 51.424 399.763 51.712 397.219 51.856C394.723 51.952 391.195 52 386.635 52V41.56Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M420.461 2.464H434.861V52H420.461V2.464Z"
                stroke="white"
                strokeWidth="2"
              />
              <path
                d="M444.227 2.464H458.627V52H444.227V2.464ZM461.651 40.984H462.227C464.579 40.984 466.235 40.888 467.195 40.696C468.203 40.456 468.947 39.928 469.427 39.112C469.955 38.248 470.243 36.88 470.291 35.008C470.387 32.608 470.435 30.016 470.435 27.232C470.435 24.496 470.387 21.88 470.291 19.384C470.195 17.512 469.883 16.144 469.355 15.28C468.875 14.416 468.083 13.888 466.979 13.696C465.875 13.552 464.291 13.48 462.227 13.48H461.651V2.464H462.227C466.067 2.464 469.259 2.632 471.803 2.96799C474.395 3.304 476.531 3.832 478.211 4.552C479.843 5.272 481.139 6.256 482.099 7.504C483.059 8.752 483.755 10.312 484.187 12.184C484.571 13.864 484.811 15.856 484.907 18.16C485.051 20.416 485.123 23.44 485.123 27.232C485.123 31.072 485.051 34.12 484.907 36.376C484.811 38.632 484.571 40.6 484.187 42.28C483.755 44.152 483.059 45.712 482.099 46.96C481.139 48.208 479.843 49.192 478.211 49.912C476.531 50.632 474.395 51.16 471.803 51.496C469.259 51.832 466.067 52 462.227 52H461.651V40.984Z"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
          </div>
          <div id="aboutMe" className="aboutme">
            <div className="heading"> Some About My Self </div>
            AoA <br /> &nbsp;&nbsp;I am Usama Majid. A MERN Stack Developer.
            MERN(MongoDB, Express JS, React JS, Node JS).
            <br /> &nbsp;&nbsp;I learn .NET, Java, C++ in my university courses,
            but I learn Node JS, React JS etc. as an internee, this internship
            was not the typical one, actually I was just monitored there and I
            learn these technologies and now I am interested in Node, React as
            my career, maybe later preferences will be changed, but right now I
            have an interest in them. But I can also learn other frameworks,
            technologies, and tools according to industry standards. I am open
            to these types of circumstances.
          </div>
          <div id="skills" className="skills">
            <div className="heading">Skills</div>
            <ul>
              <li> ----> React JS</li>
              <li> ----> Node JS</li>
              <li> ----> Redux</li>
              <li> ----> MongoDB</li>
            </ul>
            <br />
            &nbsp;&nbsp; In Node JS , I use Express JS for routing. And mostly
            use MongoDB for database. Also use mongoose for MongoDb operations.
            <br /> At front-end I use React JS. and also have some experience of
            Redux for state managment. Actually my designing is not good but I
            can design well from pre made designs.
          </div>
          <div id="certificates" className="certificates">
            <div className="heading">Certificate</div>
            <div className="subHead">Node JS Course Completion certificate</div>
            <br />
            <ul>
              <li>
                ---->&nbsp;
                <a
                  href="https://www.coursera.org/account/accomplishments/certificate/WMH3NEWPK3X7"
                  target="_blank"
                  className="link"
                >
                  Click It to check it out
                </a>
              </li>
            </ul>
          </div>
          <div id="works" className="works">
            <div className="heading">Some Of My Works</div>
            <ul>
              <li>
                ---->&nbsp;
                <a
                  href="https://covid-19-status-by-fst.netlify.com/"
                  target="_blank"
                  className="link"
                >
                  COVID-19 (Corona Virus Statistics)
                </a>
              </li>
              <li>
                ---->&nbsp;
                <a
                  href="https://ramadan-calendar-2020.netlify.com/"
                  target="_blank"
                  className="link"
                >
                  RAMADAN Calendar 2020
                </a>
              </li>
            </ul>
            <br />
            Corona Statistics is written in React JS alone. <br />
            But RAMADAN Calendar also have back end which is written in Node JS.
            Its front end is also in React JS. In RAMADAN Calendar image is also
            generating according to user city. And that image is generating at
            node server.
          </div>
          <div id="contactMe" className="contact">
            <div className="heading">Contact Me</div>
            <div className="subHead">Email</div>
            ---->&nbsp;
            <a className="link" href="mailto:usamamajid6@gmail.com">
              usamamajid6@gmail.com
            </a>
            <div className="subHead">WhatsApp</div>
            ---->&nbsp; +923345335288
          </div>
          <div className="footer">
            By Usama Majid <br />
            All Rights Reserved
          </div>
        </div>
      </div>
    );
  }
}

export default App;
